import { promiseWrapper } from 'utils/promise'

export interface Domains {
  base?: string
  base_user?: string
  registry?: string
  login?: string
  facebook?: string
  twitter?: string
  youtube?: string
}

export const getDomainsFromAPI = async (): Promise<Domains> => {
  return promiseWrapper<Domains, never>(`${window.location.origin}/wp-json/support/domains`, 'GET')
}
